import React from "react";

const LinktreeBrand2 = ({ width = 32, height = 32 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.873047" width="32" height="32" rx="4" fill="#43E660" />
    <g clip-path="url(#clip0_3746_105644)">
      <path
        d="M15.0686 20.1616H18.6595V28H15.0686V20.1616ZM6.76758 12.1275H12.8777L8.53399 8.1244L10.9375 5.73558L15.0784 9.85066V4H18.6691V9.85066L22.81 5.74495L25.2116 8.1244L20.87 12.1182H26.9781V15.4214H20.8351L25.2059 19.5271L22.81 21.8601L16.8738 16.0933L10.9375 21.8601L8.53399 19.5366L12.9065 15.4308H6.76758V12.1275Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_3746_105644">
        <rect
          width="20.2105"
          height="24"
          fill="white"
          transform="translate(6.76758 4)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default LinktreeBrand2;
